/**
 * Member status color map for cadences-v2.
 *
 * The backend now computes all status display logic and ships:
 *   displayStatus      — snake_case enum key (maps into STATUS_COLORS)
 *   displayStatusLabel — human-readable label, render directly
 *   statusExplanation  — full explanation text or null (use for tooltip body)
 *   statusTooltipTitle — short tooltip header or null
 *
 * Usage:
 *   import { STATUS_COLORS } from '../utils/member-status';
 *   const colors = STATUS_COLORS[member.displayStatus] || STATUS_COLORS.n_a;
 *   <Badge style={{ background: colors.bg, color: colors.color }}>
 *     {member.displayStatusLabel}
 *   </Badge>
 *   {member.statusExplanation && (
 *     <Tooltip title={member.statusTooltipTitle}>{member.statusExplanation}</Tooltip>
 *   )}
 */

export const STATUS_COLORS = {
  // -- Cadence / Prospect Plan lifecycle statuses --
  n_a: { bg: '#f3f4f6', color: '#6b7280' },
  not_applicable: { bg: '#f3f4f6', color: '#6b7280' },
  enrolled: { bg: '#dbeafe', color: '#2563eb' },
  in_progress: { bg: '#dbeafe', color: '#2563eb' },
  paused: { bg: '#fef3c7', color: '#d97706' },
  completed: { bg: '#dcfce7', color: '#16a34a' },
  early_exit_manual: { bg: '#fee2e2', color: '#dc2626' },
  early_exit_auto_removed: { bg: '#f3e8ff', color: '#7c3aed' },
  early_exit_configured: { bg: '#f3e8ff', color: '#7c3aed' },
  early_exit_skipped_send: { bg: '#fef3c7', color: '#92400E' },
  early_exit_skipped: { bg: '#fef3c7', color: '#92400E' },
  early_exit_failed_send: { bg: '#fee2e2', color: '#dc2626' },
  early_exit_auto_exit: { bg: '#f3e8ff', color: '#7c3aed' },

  // -- Bulk Message delivery statuses --
  send_scheduled: { bg: '#e0f2fe', color: '#0369a1' },
  pending: { bg: '#dbeafe', color: '#2563eb' },
  delivered: { bg: '#dcfce7', color: '#16a34a' },
  failed_send: { bg: '#fee2e2', color: '#dc2626' },
  skipped: { bg: '#fef3c7', color: '#92400E' },
  unsubscribed: { bg: '#f3e8ff', color: '#7c3aed' },
  opened: { bg: '#dcfce7', color: '#16a34a' },
  clicked: { bg: '#dcfce7', color: '#16a34a' },
  replied: { bg: '#dcfce7', color: '#16a34a' },

  // -- Legacy raw status values (still returned from some queries) --
  active: { bg: '#dbeafe', color: '#2563eb' },
  removed: { bg: '#fee2e2', color: '#dc2626' },
  stalled: { bg: '#fef3c7', color: '#92400E' },
  blocked: { bg: '#fee2e2', color: '#991B1B' },
  error: { bg: '#fee2e2', color: '#dc2626' },
};
